import '@babel/polyfill'
import 'core-js'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import '@/plugins/vuetify'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n/i18n'
// import * as directives from './directives/_directives'
import axios from 'axios'
import App from '@/App.vue'
import router from '@/router'
import RouterPrefetch from 'vue-router-prefetch'
// import VueBrowserUpdate from 'vue-browserupdate'

import { store } from './store'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'
// import 'roboto-fontface/css/roboto/roboto-fontface.css'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'

// prefetch route
Vue.use(RouterPrefetch)

// axios.defaults.baseURL = randomBaseUrl(0, 3)
// console.log(randomBaseUrl(0, 3))

// axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
// http://localhost:8081/beeform/hotel/bin/

const token = store.getters['auth/isAuthenticated']
// NOTE: maybe we need one more checkup for the Authorization but it's look ok
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

// initialize custom directives
// for (const directive in directives) {
//   Vue.directive(directive, directives[directive])
// }

Vue.config.productionTip = false

new Vue({
  router: router,
  store: store,
  vuetify: vuetify,
  i18n: i18n,
  render: h => h(App)
}).$mount('#app')
